export const setPasswordFormikConstants = {
    password: "password",
    confirmPassword: "confirmPassword",
}

export default {
    [setPasswordFormikConstants.password]: "",
    [setPasswordFormikConstants.confirmPassword]: "",
}